module.exports = __webpack_public_path__ + "static/desktop/img/templates-3.da946327.png";